import _ from 'lodash';
import isSome from './isSome';
import { isObservableArray } from 'mobx';

function FindParams(options) {
	if (_.isObject(options)) {
		_.extend(this, options);
		if (
			options.hasOwnProperty('orderBy') &&
			options.hasOwnProperty('orderDirection') &&
			!_.isNil(options.orderBy) &&
			!_.isNil(options.orderDirection)
		) {
			const fields = options.orderBy.split(',');
			this.sort = '';
			this.sort = fields.map(field => `${field}|${options.orderDirection}`).join(',');
			delete this.orderBy;
			delete this.orderDirection;
		}
		if (options.hasOwnProperty('search') && options.search !== '') {
			this.searchQuery = options.search;
			delete this.search;
		}
		if (options.hasOwnProperty('statusId') && options.statusId !== '') {
			this.statusId = options.statusId;
			delete this.search;
		}
		if (options.hasOwnProperty('pageNumber')) {
			this.page = options.pageNumber;
			delete this.pageNumber;
		}
		if (options.hasOwnProperty('pageSize')) {
			this.rpp = options.pageSize;
			delete this.pageSize;
		}
		if (options.hasOwnProperty('embed') && isSome(options.embed)) {
			this.embed = _.join(options.embed);
		}
		if (options.hasOwnProperty('getUnlinkedOrderLines')) {
			this.getUnlinkedOrderLines = true;
		}
		if (options.hasOwnProperty('searchFields')) {
			if (_.isArray(options.searchFields) || isObservableArray(options.searchFields)) {
				this.searchFields = _.join(options.searchFields);
			} else {
				this.searchFields = options.searchFields;
			}
		}
		if (options.hasOwnProperty('isDeleted') && options.isDeleted === true) {
			this.isDeleted = true;
		}
		if (options.hasOwnProperty('barcode')) {
			this.barcode = options.barcode;
		}
		if (options.hasOwnProperty('pallet')) {
			this.pallet = options.pallet;
		}
		if (options.hasOwnProperty('showUserFilter')) {
			this.showUserFilter = options.showUserFilter;
		}
	} else {
		this.searchQuery = options;
	}
}

function KeyParams(id, options, propName) {
	if (_.isObject(id)) {
		_.extend(this, id);
	} else {
		if (propName !== undefined) {
			this[propName] = id;
		} else {
			this['id'] = id;
		}
	}

	if (options !== undefined && _.isObject(options)) {
		_.extend(this, options);
	}
}

function findParams(options) {
	return new FindParams(options);
}

function getParams(id, options, propName) {
	return new KeyParams(id, options, propName);
}

export { findParams, getParams };
